var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.0093C6.45 21.0093 5.97917 20.8134 5.5875 20.4218C5.19583 20.0301 5 19.5593 5 19.0093V6.00928H4V4.00928H9V3.00928H15V4.00928H20V6.00928H19V19.0093C19 19.5593 18.8042 20.0301 18.4125 20.4218C18.0208 20.8134 17.55 21.0093 17 21.0093H7ZM17 6.00928H7V19.0093H17V6.00928ZM9 17.0093H11V8.00928H9V17.0093ZM13 17.0093H15V8.00928H13V17.0093Z",
    fill: "#BC400A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.36034220de9da396a057b5de0d18f33b.svg";
export { ForwardRef as ReactComponent };